import { descripcionesPlatos, entradas, combos, modals } from "./DescripcionesPlatos";
import fallbackBurger from "../../img/ImgProducts/burger.webp";

import PromoClassic4 from "../../img/promo1.webp";
import PromoClassic3 from "../../img/ImgProducts/Pc3.webp";

import PromoLM1 from "../../img/pLunesMartes/1.webp";
import PromoLM2 from "../../img/pLunesMartes/2.webp";
import PromoLM3 from "../../img/pLunesMartes/3.webp";
import PromoLM4 from "../../img/pLunesMartes/4.webp";
import PromoLM5 from "../../img/pLunesMartes/5.webp";
import PromoLM6 from "../../img/pLunesMartes/6.webp";
import PromoLM7 from "../../img/pLunesMartes/7.webp";
import PromoLM8 from "../../img/pLunesMartes/8.webp";
import PromoLM9 from "../../img/pLunesMartes/9.webp";

import DuoGranjero from "../../img/promoDuo/granjeroS.webp";
import DuoCarne from "../../img/promoDuo/hCarne.webp";
import DuoCheese from "../../img/promoDuo/cheeseBurguer.webp";
import DuoCheddar from "../../img/promoDuo/cheddarMelt.webp";
import DuoCrispy from "../../img/promoDuo/cryspyMelt.webp";
import DuoHotDog from "../../img/promoDuo/hClassic.webp";
import DuoPapas from "../../img/promoDuo/pr.webp";

import HdCheddar from "../../img/HotDogs/3.webp";
import HdBacon from "../../img/HotDogs/4.webp";
import HdClassic from "../../img/HotDogs/5.webp";
import HdEspecial from "../../img/HotDogs/6.webp";
import StreetBurger from "../../img/original-1AB79CA0-B9F1-4C87-B533-9EEF8CD4EAA0.jpeg";

const PROMOS_POR_NOMBRE = {
  "390 Promo Classic x3": PromoClassic3,
  "390 Promo Classic x4": PromoClassic4,
  "390 Street Burger": StreetBurger,
  "Promo 1": PromoLM1,
  "Promo 2": PromoLM2,
  "Promo 3": PromoLM3,
  "Promo 4": PromoLM4,
  "Promo 5": PromoLM5,
  "Promo 6": PromoLM6,
  "Promo 7": PromoLM7,
  "Promo 8": PromoLM8,
  "Promo 9": PromoLM9,
  "Granjero Sencillo Duo": DuoGranjero,
  "Hamburguesa de Carne Duo": DuoCarne,
  "Cheese Burguer Duo": DuoCheese,
  "Cheddar Melt Duo": DuoCheddar,
  "Crispy Cheddar Melt Duo": DuoCrispy,
  "Hot Dog Classic Duo": DuoHotDog,
  "Papas Regulares Duo": DuoPapas,
  "Papas regulares": DuoPapas,
  "Papas grandes": DuoPapas,
  "Maxi Papas": DuoPapas,
  "CHEDDAR MELT": HdCheddar,
  "CLASSIC BACON": HdBacon,
  CLASSIC: HdClassic,
  ESPECIAL: HdEspecial,
};

const CATALOGOS = [descripcionesPlatos, entradas, combos];

const normalizar = (nombre = "") =>
  nombre
    .replace(/\s*\(x\d+\)\s*$/i, "")
    .trim()
    .toLowerCase();

const esUrlImagen = (valor) =>
  typeof valor === "string" &&
  valor.length > 0 &&
  !valor.includes("[object") &&
  (valor.startsWith("/") || valor.startsWith("http") || valor.startsWith("data:") || valor.startsWith("blob:"));

const buscarEnCatalogo = (nombreNorm) => {
  for (const cat of CATALOGOS) {
    const clave = Object.keys(cat).find((k) => normalizar(k) === nombreNorm);
    if (clave && cat[clave]?.productoImg) return cat[clave].productoImg;
  }
  return null;
};

const primeraImagenValida = (...candidatas) => candidatas.find((img) => esUrlImagen(img));

const cantidadHamburguesasPromo = (item) => {
  const candidatas = [
    item?.promo?.parentPromo?.cantidad,
    item?.parentPromo?.cantidad,
    item?.promo?.cantidad,
    Array.isArray(item?.hamburguesas) && item.hamburguesas.length > 1
      ? item.hamburguesas.length
      : null,
  ];
  const n = candidatas.find((v) => typeof v === "number" && v > 1);
  return n ?? null;
};

const precioPromo = (item) => {
  const valor = item?.precio ?? item?.promo?.precio ?? item?.promo?.promos?.[0]?.precio;
  if (valor == null || valor === "") return null;
  const n = parseFloat(String(valor).replace(",", "."));
  return Number.isFinite(n) ? n : null;
};

const nombrePadrePromo = (item) =>
  item?.promo?.parentPromo?.nombre || item?.parentPromo?.nombre || item?.promo?.nombrePadre || null;

const coincideNombrePromo = (modal, nombreNorm) =>
  normalizar(modal.nombre) === nombreNorm ||
  modal.promos?.some((p) => normalizar(p.nombre) === nombreNorm);

const imagenClassicPorCantidad = (cantidad) => {
  if (cantidad === 3) return PromoClassic3;
  if (cantidad === 4) return PromoClassic4;
  return null;
};

const esPromoClassic = (nombreNorm) =>
  nombreNorm === "390 promo classic" ||
  nombreNorm.startsWith("390 promo classic");

const resolverImagenModal = (item, nombreNorm) => {
  const coincidencias = modals.filter((modal) => modal.img && coincideNombrePromo(modal, nombreNorm));
  if (coincidencias.length === 0) return null;
  if (coincidencias.length === 1) return coincidencias[0].img;

  const nombrePadre = nombrePadrePromo(item);
  if (nombrePadre) {
    const porPadre = coincidencias.find((m) => m.nombre === nombrePadre);
    if (porPadre?.img) return porPadre.img;
  }

  const qty = cantidadHamburguesasPromo(item);
  if (qty != null) {
    const porCantidad = coincidencias.find((m) => m.cantidad === qty);
    if (porCantidad?.img) return porCantidad.img;
  }

  const precio = precioPromo(item);
  if (precio != null) {
    const porPrecio = coincidencias.find((m) =>
      m.promos?.some((p) => parseFloat(String(p.precio).replace(",", ".")) === precio)
    );
    if (porPrecio?.img) return porPrecio.img;
  }

  return coincidencias[0].img;
};

export const resolverImagenProducto = (item) => {
  if (!item) return fallbackBurger;

  const nombrePadre = nombrePadrePromo(item);
  if (nombrePadre) {
    const modalPadre = modals.find((m) => m.nombre === nombrePadre && m.img);
    if (modalPadre?.img) return modalPadre.img;
  }

  const qty = cantidadHamburguesasPromo(item);
  const nombreParaClassic = normalizar(
    (item.nombre || item.promo?.nombre || "").replace(/\s*\(x\d+\)\s*$/i, "")
  );
  if (esPromoClassic(nombreParaClassic)) {
    const imgClassic = imagenClassicPorCantidad(qty);
    if (imgClassic) return imgClassic;

    const precio = precioPromo(item);
    if (precio === 30.98) return PromoClassic3;
    if (precio === 39.99) return PromoClassic4;
  }

  const guardada = primeraImagenValida(
    item.productoImg,
    item.img,
    item.promo?.productoImg,
    item.promo?.img,
    item.promo?.parentPromo?.img,
    item.parentPromo?.img
  );
  if (guardada) return guardada;

  const nombreRaw = (item.nombre || "").replace(/\s*\(x\d+\)\s*$/i, "").trim();
  if (!nombreRaw) return fallbackBurger;

  for (const cat of CATALOGOS) {
    if (cat[nombreRaw]?.productoImg) return cat[nombreRaw].productoImg;
  }

  const nombreNorm = normalizar(nombreRaw);
  const exactaCatalogo = buscarEnCatalogo(nombreNorm);
  if (exactaCatalogo) return exactaCatalogo;

  if (PROMOS_POR_NOMBRE[nombreRaw]) return PROMOS_POR_NOMBRE[nombreRaw];
  const promoKey = Object.keys(PROMOS_POR_NOMBRE).find((k) => normalizar(k) === nombreNorm);
  if (promoKey) return PROMOS_POR_NOMBRE[promoKey];

  const imagenModal = resolverImagenModal(item, nombreNorm);
  if (imagenModal) return imagenModal;

  return fallbackBurger;
};
